/**
 * @module actions/carrentalcontracts
 */
import axios from 'axios'
import { API_URL } from '../constants'

/**
 * @description Gets CarRentalContract data for an order/carRental combination
 * @return {Promise} Axios promise
 */
export function getCarRentalContract (orderId, carRentalId, forceNew) {
  let url = API_URL + '/CarRentalContract/Get/'
  let data = { OrderId: orderId, CarRentalId: carRentalId, ForceNew: forceNew }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Updates CarRentalContract data for an order/carRental combination
 * @return {Promise} Axios promise
 */
export function updateCarRentalContract (contractData) {
  let url = API_URL + '/CarRentalContract/Update/'
  return dispatch => {
    return axios.post(url, contractData)
  }
}




// WEBPACK FOOTER //
// ./src/app/actions/carrentalcontracts.js